export default __webpack_public_path__ + "static/media/featRaceBg.d5b34b58.png";